import { Link } from "react-router-dom";
import { useState, useEffect } from "react";


import { 
  FaMapMarkerAlt, 
  FaEnvelope, 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn,
  FaCcVisa,
  FaCcMastercard,
  FaCcPaypal,
  FaCcAmex,
  FaArrowRight,
  FaShieldAlt,
  FaTruck,
  FaUndo
} from "react-icons/fa";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // future: API call / backend integration
    console.log("Newsletter Email:", email);
    setIsSubmitted(true);
    setEmail("");
    setTimeout(() => setIsSubmitted(false), 3000);
  };

  const categories = [
    { name: "Injectables", link: "/athligo/injectable", count: 12 },
    { name: "Orals Anabolics", link: "/athligo/orals", count: 8 },
    { name: "Supplements", link: "/athligo/suplements", count: 10 },
    {/* name: "Sports Nutrition", link: "/athligo/sports-nutritions", count: 15 */}
  ];

  const quickLinks = [
    { name: "About Us", link: "/about" },
    { name: "Contact Us", link: "/contact" },
    { name: "Authentication Code", link: "/authenticate" },
  ];

  return (
    <footer className="relative bg-gradient-to-b from-gray-900 to-black text-gray-300 pt-16 pb-6 overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-red-600/10 to-amber-600/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-blue-600/10 to-purple-600/10 rounded-full blur-3xl"></div>
        
        {/* Grid Pattern */}
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
          }}
        ></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10">
        
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          
          {/* Company Info - Get In Touch */}
          <div className="lg:col-span-4 space-y-6">
            {/* Logo/Brand */}
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-gradient-to-br from-red-600 to-amber-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">DD</span>
              </div>
              <span className="text-white font-bold text-2xl">Dark Drag</span>
            </div>

            <div>
              <h3 className="text-white text-lg font-semibold mb-3 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-red-600"></span>
                Get In Touch
              </h3>

              <ul className="space-y-4 text-sm">
                <li className="flex gap-3 group">
                  <FaMapMarkerAlt className="text-red-500 mt-1 group-hover:scale-110 transition-transform" />
                  <span className="text-gray-400 group-hover:text-white transition-colors">
                    Strada Mitropolit Gavrill, Banulescu-Bodoni 429,  
                    Chisinau, Moldova
                  </span>
                </li>

                <li className="flex gap-3 group">
                  <FaEnvelope className="text-red-500 mt-1 group-hover:scale-110 transition-transform" />
                  <a
                    href="dark@darkdrag.com"
                    className="text-gray-400 hover:text-red-500 transition-colors"
                  >
                    dark@darkdrag.com
                  </a>
                </li>
              </ul>

              <p className="mt-5 text-sm text-gray-400 leading-relaxed">
                We are one of the best manufacturers throughout the country.
                We only use high-quality raw material in our products.
              </p>
            </div>

            {/* Social Links */}
            <div className="flex gap-3">
              {[
                { icon: FaFacebookF, link: "#", color: "hover:bg-blue-600" },
                { icon: FaTwitter, link: "#", color: "hover:bg-sky-500" },
                { icon: FaInstagram, link: "#", color: "hover:bg-pink-600" },
                { icon: FaLinkedinIn, link: "#", color: "hover:bg-blue-700" },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  className={`w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center hover:bg-red-600 transition-all duration-300 hover:scale-110`}
                >
                  <social.icon className="text-white text-sm" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links & Categories */}
          <div className="lg:col-span-5 grid grid-cols-2 gap-8">
            {/* Categories */}
            <div>
              <h3 className="text-white text-lg font-semibold mb-3 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-red-600"></span>
                Categories
              </h3>
              <ul className="space-y-3">
                {categories.map((cat) => (
                  <li key={cat.name}>
                    <Link
                      to={cat.link}
                      className="text-sm text-gray-400 hover:text-red-500 transition-colors flex items-center justify-between group"
                    >
                      <span className="group-hover:translate-x-1 transition-transform">
                        {cat.name}
                      </span>
                      <span className="text-xs bg-white/5 px-2 py-0.5 rounded-full">
                        {cat.count}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-white text-lg font-semibold mb-3 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-red-600"></span>
                Quick Links
              </h3>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.link}
                      className="text-sm text-gray-400 hover:text-red-500 transition-colors inline-block hover:translate-x-1 transform transition-transform"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Newsletter & Trust Badges */}
          <div className="lg:col-span-3 space-y-6">
            {/* Newsletter */}
            <div>
              <h3 className="text-white text-lg font-semibold mb-3 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-red-600"></span>
                Newsletter
              </h3>
              
              <form onSubmit={handleSubmit} className="space-y-3">
                <div className="relative">
                  <input
                    type="email"
                    required
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full bg-white/5 border border-gray-700 px-4 py-3 text-sm rounded-lg outline-none focus:border-red-600 focus:bg-white/10 transition-all pr-24"
                  />
                  <button
                    type="submit"
                    className="absolute right-1 top-1 bg-gradient-to-r from-red-600 to-amber-600 text-white text-sm px-4 py-2 rounded-lg font-semibold hover:from-red-700 hover:to-amber-700 transition-all flex items-center gap-1 group"
                  >
                    <span>Send</span>
                    <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
                {isSubmitted && (
                  <p className="text-green-500 text-xs">Thanks for subscribing!</p>
                )}
              </form>
            </div>

            {/* Trust Badges */}
            {/*<div>
              <h3 className="text-white text-sm font-semibold mb-3">
                We Accept
              </h3>
              <div className="flex gap-2">
                <FaCcVisa className="w-8 h-8 text-gray-400 hover:text-white transition-colors" />
                <FaCcMastercard className="w-8 h-8 text-gray-400 hover:text-white transition-colors" />
                <FaCcPaypal className="w-8 h-8 text-gray-400 hover:text-white transition-colors" />
                <FaCcAmex className="w-8 h-8 text-gray-400 hover:text-white transition-colors" />
              </div>
            </div>*/}

            {/* Features */}
            {/*<div className="grid grid-cols-2 gap-2">
              {[
                { icon: FaShieldAlt, text: "Secure Payment" },
                { icon: FaTruck, text: "Free Shipping" },
                { icon: FaUndo, text: "30-Day Returns" },
                { icon: FaMapMarkerAlt, text: "Track Order" },
              ].map((feature, index) => (
                <div key={index} className="flex items-center gap-2 text-xs text-gray-400">
                  <feature.icon className="text-red-500" />
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>*/}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-gray-500">
              © {new Date().getFullYear()} Dark Drag Anabolic. All Rights Reserved.
            </p>
            
            {/* Legal Links */}
            <div className="flex gap-4 text-xs">
              <Link to="/terms" className="text-gray-500 hover:text-red-500 transition-colors">
                Terms of Use
              </Link>
              <Link to="/privacy" className="text-gray-500 hover:text-red-500 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/cookies" className="text-gray-500 hover:text-red-500 transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;